import Thoth from '../base/thoth';

class BankService extends Thoth {
    index() {
        return this.fetch({ url: 'bank' });
    }
}

export default new BankService();
